function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import { connect } from 'redux-bundler-react';
import { withTranslation } from 'react-i18next';
import StrokeIpld from '../../icons/StrokeIpld';

var IpldExploreForm = /*#__PURE__*/function (_React$Component) {
  _inherits(IpldExploreForm, _React$Component);

  var _super = _createSuper(IpldExploreForm);

  function IpldExploreForm(props) {
    var _this;

    _classCallCheck(this, IpldExploreForm);

    _this = _super.call(this, props);
    _this.state = {
      path: ''
    };
    _this.handleOnChange = _this.handleOnChange.bind(_assertThisInitialized(_this));
    _this.handleOnSubmit = _this.handleOnSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(IpldExploreForm, [{
    key: "handleOnSubmit",
    value: function handleOnSubmit(evt) {
      evt.preventDefault();
      this.props.doExploreUserProvidedPath(this.state.path);
    }
  }, {
    key: "handleOnChange",
    value: function handleOnChange(evt) {
      var path = evt.target.value;
      this.setState({
        path: path
      });
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/React.createElement("form", {
        "data-id": "IpldExploreForm",
        className: "sans-serif black-80 flex",
        onSubmit: this.handleOnSubmit
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "relative"
      }, /*#__PURE__*/React.createElement("input", {
        id: "ipfs-path",
        className: "input-reset bn pa2 mb2 db w-100 f6 br-0 placeholder-light focus-outline",
        style: {
          borderRadius: '3px 0 0 3px'
        },
        type: "text",
        placeholder: "QmHash",
        "aria-describedby": "name-desc",
        onChange: this.handleOnChange,
        value: this.state.path
      }), /*#__PURE__*/React.createElement("small", {
        id: "ipfs-path-desc",
        className: "o-0 absolute f6 black-60 db mb2"
      }, "Paste in a CID or IPFS path"))), /*#__PURE__*/React.createElement("div", {
        className: "flex-none"
      }, /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: "button-reset dib lh-copy pv1 pl2 pr3 ba f7 fw4 focus-outline white bg-aqua bn",
        style: {
          borderRadius: '0 3px 3px 0'
        }
      }, /*#__PURE__*/React.createElement(StrokeIpld, {
        style: {
          height: 24
        },
        className: "dib fill-current-color v-mid"
      }), /*#__PURE__*/React.createElement("span", {
        className: "ml2"
      }, t('IpldExploreForm.explore')))));
    }
  }]);

  return IpldExploreForm;
}(React.Component);

export default connect('doExploreUserProvidedPath', withTranslation('explore')(IpldExploreForm));